module.exports = __webpack_public_path__ + "media/Eclipse_Plain.72bb06b8.mp3";